import { styled, Typography, Box } from '@mui/material';

export const TitleContainer = styled(Box)({
  padding: 24,
});

export const Title = styled(Typography)(({ theme }) => ({
  ...theme.typography.textMdMedium,
  color: theme.palette.grey[900],
  textAlign: 'center',
}));
